import PropTypes from "prop-types"

export const MPackage = PropTypes.shape({
  description:      PropTypes.string.isRequired,   // aka short description
  destination:      PropTypes.string.isRequired,   // "Las Vegas, NV"
  full_description: PropTypes.string.isRequired,   // long description
  gifts:            PropTypes.array.isRequired,    // gifts array of objects, own shape?
  hero_images:      PropTypes.array.isRequired,    // image path relative to /images
  hotel:            PropTypes.string,              // Hotel types you can get
  id:               PropTypes.string.isRequired,   // las-vegas-the-vegas-party: city-package name
  images:           PropTypes.array.isRequired,    // array of image paths
  keywords:         PropTypes.array.isRequired,    // array of keywords of search and page meta
  length_of_stay_in_days:   PropTypes.number.isRequired, // # days for Package duration
  length_of_stay_in_nights:   PropTypes.number.isRequired, // # nights for Package duration
  location:         PropTypes.object.isRequired,   // { city: '', state: ''}
  price:            PropTypes.object.isRequired,   // { full: '1600', discount: '599', sale: '249'}
  title:            PropTypes.string.isRequired,   // Package title: "The Vegas Party"
  state_full:       PropTypes.string.isRequired,   // "Nevada": needed for Fuse search
  package_prefix:   PropTypes.string,              // "starting at" etc
  package_for:      PropTypes.string.isRequired,   // "per couple" "per family" etc
})


export const MPackageList = PropTypes.shape({
  description:      PropTypes.string.isRequired,   // aka short description
  destination:      PropTypes.string.isRequired,   // "Las Vegas, NV"
  full_description: PropTypes.string,              // long description
  gifts:            PropTypes.array.isRequired,    // gifts array of objects, own shape?
  hero_images:      PropTypes.array.isRequired,    // image path relative to /images
  hotel:            PropTypes.string,              // Hotel types you can get
  id:               PropTypes.string.isRequired,   // las-vegas-the-vegas-party: city-package name
  images:           PropTypes.array.isRequired,    // array of image paths
  keywords:         PropTypes.array.isRequired,    // array of keywords of search and page meta
  length_of_stay_in_days:   PropTypes.number.isRequired,   // # days for Package duration
  length_of_stay_in_nights:   PropTypes.number.isRequired,   // # nights for Package duration
  location:         PropTypes.object.isRequired,   // { city: '', state: ''}
  price:            PropTypes.object.isRequired,   // { full: '1600', discount: '599', sale: '249'}
  title:            PropTypes.string.isRequired,   // Package title: "The Vegas Party"
  state_full:       PropTypes.string,              // "Nevada": needed for Fuse search
  package_for:      PropTypes.string.isRequired,   // "per couple" "per family" etc
})
